import React, { createContext, useEffect, useContext } from 'react';
import { useMergeState } from '@/common/useMergeState';
import { updateHeaders } from '@/utils/request';
import { getUserInfo } from '@/services/user';
import storage, { EnumCacheKey } from '@/utils/storage';
import useOnceRun from '@/common/useOnceRun';
import { useRouter } from 'next/router';
import Observer, { OB_KEYS } from '@/utils/observer';
export const BaseContext = createContext({
  appData: {
    userInfo: {},
    funcPrice: {}
  },
  setAppData: () => {},
  updateUser: () => {}
});
export const BaseProvider = ({ children }) => {
  const router = useRouter();
  const [appData, setAppData] = useMergeState({
    isVip: false,
    hasReady: false,
    hasLogin: false,
    uid: 0,
    userInfo: {}
  });

  const updateUserInfo = ({}) => {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then((data) => {
          if (data && data.uid) {
            setAppData((draft) => {
              draft.hasLogin = true;
              draft.userInfo = data;
              draft.isVip = data?.subscribeExpireTime > Date.now();
              draft.uid = data.uid;
            });
            storage.setItem(EnumCacheKey['app/user/uid'], data.uid);

            resolve();
          } else {
            reject();
          }
        })
        .catch(() => {}) //.catch(reject)
        .finally(() => {
          setAppData((draft) => {
            draft.hasReady = true;
          });
        });
    });
  };

  const updateUser = (data) => {
    const { accessToken: token } = data || {};
    if (!token) return Promise.reject();
    updateHeaders('authorization', token);

    return updateUserInfo();
  };

  return (
    <BaseContext.Provider
      value={{
        appData,
        setAppData,
        updateUser,
        updateUserInfo
      }}
    >
      {children}
    </BaseContext.Provider>
  );
};

export const useGlobalStore = () => {
  return useContext(BaseContext);
};

export default BaseProvider;
